// this is the main starting point for deridoc frontend.
// globally used methods, libs, filters etc should be defined here.
// webpack starts looking for dependencies here as well

'use strict'

import Vue from 'vue'
import App from './App.vue'
import router from './core/Router'
import merge from 'lodash/merge'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'
import get from 'lodash/get'
import identity from 'lodash/identity'
import isArray from 'lodash/isArray'
import isObject from 'lodash/isObject'
import clone from 'lodash/clone'
import last from 'lodash/last'
import indexOf from 'lodash/indexOf'
import orderBy from 'lodash/orderBy'
import sortBy from 'lodash/sortBy'
import isUndefined from 'lodash/isUndefined'
import isNil from 'lodash/isNil'
import find from 'lodash/find'
import union from 'lodash/union'
import store from './core/Store'
import VueHead from 'vue-head'
import * as filters from './core/Filters'
import moment from 'moment'
import 'moment/locale/de'

process.env.TZ = 'Europe/Berlin'
moment.locale('de')

// use selected lodash methods
Object.defineProperty(Vue.prototype, '_', {
  value: {
    merge,
    pickBy,
    mapValues,
    get,
    identity,
    isArray,
    isObject,
    clone,
    last,
    indexOf,
    orderBy,
    isUndefined,
    isNil,
    sortBy,
    find,
    union
  }
})

Object.defineProperty(Vue.prototype, 'moment', {value: moment})

Vue.use(VueHead)
Vue.config.productionTip = false

/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  router,
  store,
  filters,
  template: '<App/>',
  components: {App}
})

app.$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js